/**
* Do not edit directly
* Generated on Fri, 15 Aug 2025 16:47:01 GMT
*/

module.exports = {
  "core": {
    "colors": {
      "transparent": "transparent",
      "current": "currentColor",
      "white": "#FFF",
      "black": "#000",
      "whiteAlpha": {
        "50": "rgba(255, 255, 255, 0.04)",
        "100": "rgba(255, 255, 255, 0.06)",
        "200": "rgba(255, 255, 255, 0.08)",
        "300": "rgba(255, 255, 255, 0.16)",
        "400": "rgba(255, 255, 255, 0.24)",
        "500": "rgba(255, 255, 255, 0.36)",
        "600": "rgba(255, 255, 255, 0.48)",
        "700": "rgba(255, 255, 255, 0.64)",
        "800": "rgba(255, 255, 255, 0.80)",
        "900": "rgba(255, 255, 255, 0.92)"
      },
      "blackAlpha": {
        "50": "rgba(0, 0, 0, 0.04)",
        "100": "rgba(0, 0, 0, 0.06)",
        "200": "rgba(0, 0, 0, 0.08)",
        "300": "rgba(0, 0, 0, 0.16)",
        "400": "rgba(0, 0, 0, 0.24)",
        "500": "rgba(0, 0, 0, 0.36)",
        "600": "rgba(0, 0, 0, 0.48)",
        "700": "rgba(0, 0, 0, 0.64)",
        "800": "rgba(0, 0, 0, 0.80)",
        "900": "rgba(0, 0, 0, 0.92)"
      },
      "pink": {
        "50": "#380017",
        "100": "#42001c",
        "200": "#500023",
        "300": "#750037",
        "400": "#b30059",
        "500": "#ff348e",
        "600": "#ff6bab",
        "700": "#ff93c0",
        "800": "#ffb1d1",
        "900": "#ffdfeb"
      },
      "red": {
        "50": "#3D0001",
        "100": "#430001",
        "200": "#510001",
        "300": "#790007",
        "400": "#B02020",
        "500": "#E26257",
        "600": "#EF7F73",
        "700": "#F89D92",
        "800": "#FCB6AE",
        "900": "#FFE1DC"
      },
      "orange": {
        "50": "#2B1203",
        "100": "#311603",
        "200": "#3B1C05",
        "300": "#5A2D0B",
        "400": "#8A4A1A",
        "500": "#CC7436",
        "600": "#E58847",
        "700": "#FB9F60",
        "800": "#FFB885",
        "900": "#FFE2CB"
      },
      "yellow": {
        "50": "#310E03",
        "100": "#371104",
        "200": "#421706",
        "300": "#5E2A0C",
        "400": "#864C14",
        "500": "#B68023",
        "600": "#C7982D",
        "700": "#D8B03B",
        "800": "#E7C546",
        "900": "#FEE5A3"
      },
      "green": {
        "50": "#001F02",
        "100": "#002303",
        "200": "#002C04",
        "300": "#00430A",
        "400": "#006A19",
        "500": "#19A036",
        "600": "#32B647",
        "700": "#56CC63",
        "800": "#7BDD82",
        "900": "#C6F3C7"
      },
      "lime": {
        "50": "#001f04",
        "100": "#002305",
        "200": "#002c08",
        "300": "#004311",
        "400": "#036921",
        "500": "#499d2a",
        "600": "#66b227",
        "700": "#88c71f",
        "800": "#a7d817",
        "900": "#dbf428"
      },
      "teal": {
        "50": "#051D1B",
        "100": "#06211F",
        "200": "#082927",
        "300": "#12403E",
        "400": "#246460",
        "500": "#499792",
        "600": "#5FACA7",
        "700": "#7DC1BC",
        "800": "#9CD1CD",
        "900": "#D6ECEA"
      },
      "cyan": {
        "50": "#041C25",
        "100": "#051F29",
        "200": "#072733",
        "300": "#113E50",
        "400": "#23617A",
        "500": "#4793B4",
        "600": "#5EA8C9",
        "700": "#7CBDDB",
        "800": "#9BCFE8",
        "900": "#D5EBF6"
      },
      "blue": {
        "50": "#031930",
        "100": "#041D36",
        "200": "#062643",
        "300": "#0E3B64",
        "400": "#1F5D97",
        "500": "#438ED9",
        "600": "#5AA3EE",
        "700": "#79B9FC",
        "800": "#99CCFF",
        "900": "#D5EAFF"
      },
      "purple": {
        "50": "#250447",
        "100": "#2a064e",
        "200": "#340b5e",
        "300": "#4d1e83",
        "400": "#6f43ac",
        "500": "#9a7bcf",
        "600": "#ac93db",
        "700": "#bface4",
        "800": "#cfc1ec",
        "900": "#eae5f7"
      },
      "gray": {
        "50": "#19181E",
        "100": "#1E1C23",
        "200": "#25232B",
        "300": "#3A383F",
        "400": "#5B5A60",
        "500": "#8B8A8E",
        "600": "#9F9FA2",
        "700": "#B5B4B7",
        "800": "#C8C7C9",
        "900": "#E8E7E8"
      },
      "constant": {
        "homebot": {
          "primary": "#FB5AA4",
          "secondary": "#62339E",
          "tertiary": "#EEFF41"
        }
      }
    }
  }
}